import styled from 'styled-components';
import { black, white, lightGrey } from 'Public/css/colors';

export default styled.div `
    
    color: ${ black };
    
    .anticon {
        background-color: ${ lightGrey };
        color: ${ white };
        border-radius: 100%;
        padding: 4px;
        font-size: 20px;
        display: inline-block;
        margin-right: 10px;
        vertical-align: middle;
    }
    
    .pipe {
        display: inline-block;
        margin: 0 3px;
        color: ${ lightGrey };
    }
  
`;